import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left-retract",
  "use": "icon-left-retract-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-left-retract\"><path d=\"M545.024 947.8144l-185.7024-377.2416a136.5504 136.5504 0 0 1 0.256-121.088l189.7472-381.44a68.2496 68.2496 0 1 1 122.2144 60.8256L481.792 510.3104l185.7536 377.1904a68.2496 68.2496 0 1 1-122.5216 60.3136z\" p-id=\"13293\" data-spm-anchor-id=\"a313x.search_index.0.i7.73913a81aG24te\" class=\"selected\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol